<template>
    <div class="header-wrapper">
        <div class="header">
            <div class="container">
                <div class="header-inner">
                    <div class="header-logo">
                        <router-link class="header-title" :to="{name: 'Home'}" active-class="">
                          <img src="../../img/EurLogo.svg" :alt="$t('main_home')">Europe Camper Parking
                        </router-link>
                    </div>
                    <div class="header-toggle toggle" @click="toggleSidebar">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <div class="header-actions" v-if="false">
                        <ul class="nav nav-pills">
                            <li class="nav-item">
                                <a href="#" class="nav-link modal-submit" id="modal-action-submit" data-toggle="modal"
                                   data-target="#modal-submit">
                                    <i class="fa fa-plus"></i> <span>Submit Listing</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Navigator',
  computed: {
    ...mapGetters(['navigationVisible', 'language', 'savedQueryParams']),
  },
  methods: {
    ...mapMutations(['toggleSidebar', 'toggleNavigation']),
    hideMobileNavigation () {
      if (this.navigationVisible) {
        this.toggleNavigation()
      }
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/utilities/Navigator.vue